export const LEGAL_SITE_URL = 'https://kamilfrajtko.sk';
export const LEGAL_SITE_NAME = 'Bc. Kamil Frajtko';
export const LEGAL_BUSINESS_NAME = 'Kamil Frajtko';
export const LEGAL_ICO = '54 125 481';
export const LEGAL_DIC = '1127687165';
export const LEGAL_EMAIL = 'kontakt@kamilfrajtko.sk';
export const LEGAL_PHONE = '+421 905 929 167';
export const LEGAL_UPDATED_AT = '13. marca 2026';

export const LEGAL_ADDRESS =
  import.meta.env.VITE_BUSINESS_ADDRESS?.trim() || '';
export const LEGAL_REGISTER_ENTRY =
  import.meta.env.VITE_TRADE_REGISTER_ENTRY?.trim() || '';

export function getLegalMissingFields() {
  const missing: string[] = [];

  if (!LEGAL_ADDRESS) {
    missing.push('miesto podnikania / adresa');
  }

  if (!LEGAL_REGISTER_ENTRY) {
    missing.push('údaj o zápise v živnostenskom alebo inom príslušnom registri');
  }

  return missing;
}
